/// <reference types="vite-plugin-terminal/client" />
import terminal from 'virtual:terminal';
import { useLogStore } from '../store/logSlice';

class LoggerService {
  log(...args: unknown[]): void {
    terminal.log(...args);
    useLogStore.getState().append('log', args);
  }
  info(...args: unknown[]): void {
    terminal.info(...args);
    useLogStore.getState().append('info', args);
  }
  warn(...args: unknown[]): void {
    terminal.warn(...args);
    useLogStore.getState().append('warn', args);
  }
  error(...args: unknown[]): void {
    terminal.error(...args);
    useLogStore.getState().append('error', args);
  }
}

export const logger = new LoggerService();
